import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-product-card-ellipsis',
  templateUrl: './product-card-ellipsis.component.html',
  styleUrls: ['./product-card-ellipsis.component.scss'],
})
export class ProductCardEllipsisComponent {
  @Input() notFound: boolean;
  @Input() isGuestUser: boolean;
  @Output() ellipsisClickEmitter: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ellipsisClick(event: any) {
    this.ellipsisClickEmitter.emit(event);
  }
}
